var render, staticRenderFns
import script from "./auth-redirect.vue?vue&type=script&lang=js"
export * from "./auth-redirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/barcode-vue_KGsn/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de6522de')) {
      api.createRecord('de6522de', component.options)
    } else {
      api.reload('de6522de', component.options)
    }
    
  }
}
component.options.__file = "src/views/login/auth-redirect.vue"
export default component.exports